import PropTypes from 'prop-types';
import { Component } from 'react';
import refluxConnector from 'core/utils/refluxConnector';
import { StudentLessonProgressActions } from '../../refluxActions';
import { StudentLessonProgressStore } from '../../refluxStores';
import LoadingIndicator from 'edrolo/domains/app/components/LoadingIndicator';

/* this is a higher order component used to wrap a component that needs access to the student
    lesson progress
*/
const studentLessonProgressLoader = function (WrappedComponent) {
  const storeConnector = refluxConnector(
    StudentLessonProgressStore,
    'lessonProgress'
  );

  class StudentLessonProgress extends Component {
    componentDidMount() {
      this.loadProgressIfNeeded();
    }

    loadProgressIfNeeded() {
      const lessonProgress = this.props.lessonProgress.lessonProgress;
      const classId = this.props.classId;
      const studentId = this.props.studentId;
      const lessonId = this.props.lessonId;
      if (!lessonProgress.getIn([studentId, lessonId])) {
        StudentLessonProgressActions.load(classId, studentId, lessonId);
      }
    }

    render() {
      return (
        <div className="student-lesson-progress">
          {this.props.lessonProgress.isLoadingLessonProgress ? (
            <LoadingIndicator loadingText="Loading Lesson Progress" />
          ) : (
            <WrappedComponent {...this.props} />
          )}
        </div>
      );
    }
  }
  StudentLessonProgress.propTypes = {
    classId: PropTypes.string.isRequired,
    studentId: PropTypes.string.isRequired,
    lessonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    lessonProgress: PropTypes.object.isRequired,
  };

  return storeConnector(StudentLessonProgress);
};

export default studentLessonProgressLoader;
